import { FC, Fragment, useState } from "react";
import { Popover } from "antd";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";

import CustomTooltip from "@pages/tool-tip";
import GetGenericDrugPopOver from "../generic-drug/generic-drug";

import "./generic-options-display-format.scss"
import { useAlternativeGenericMedicationStore } from "@stores/useAlternativeGenericMedicationStore";
import { CanEdit } from '@components/accessLevel'

interface IGenericOptionDisplayFormatProps {
  index: number;
  setCurrentOpenModalIndex: any;
  currentOpenModalIndex: any;
  currentSelectedIndex: any;
}

const GenericOptionDisplayFormat: FC<IGenericOptionDisplayFormatProps> = ({ index, setCurrentOpenModalIndex, currentOpenModalIndex, currentSelectedIndex }) => {
  const [showContentCount, setShowContentCount] = useState(5);
  const [showMoreState, setShowMoreState] = useState(true);
  const [popOverVisible, setShowPopOverVisible] = useState(false);
  const dataState = useAlternativeGenericMedicationStore((state) => state.dataState);

  const getEditGenericOptionFormat = () => {
    return (
      <div className="edit-generic-options--container">
        <span className="edit-generic-options--body">
          <CanEdit>
          <EditOutlined
            onClick={() => {
              currentSelectedIndex.current = index;
              setCurrentOpenModalIndex(index);
              setShowPopOverVisible(true);
            }}
            className="color-for--generic_options"
          />
          </CanEdit>
        </span>
        <CustomTooltip
          toolTipvalue={dataState[index].genericDrugBrand}
          children={
            <div className="f14 clr-lightGrayColor fw400 edit-generic-options--generic-options-text-body">
              <div className="edit-generic-options--tool_tip">{dataState[index].genericDrugBrand}</div>
            </div>
          }
        />
      </div>
    );
  };

  const getAddGenericOptionFormat = () => {
    return (
      <div
        className="add-generic-options color-for--generic_options"
        onClick={() => {
          currentSelectedIndex.current = index;
          setCurrentOpenModalIndex(index);
          setShowPopOverVisible(true);
        }}
      >
        <div className="add-generic-options--logo-container">
          <PlusOutlined className="add-generic-options--logo-body"/>
        </div>
        <span className="f14 fw500 cursor-type--pointer">
          Add Generic
        </span>
      </div>
    );
  };

  return (
    <Fragment key={index}>
      {(dataState[index].isGenericOptionAvailable === false || dataState[index].isGenericOptionAvailable === "false") && (
        <div className="f14 fw500 color-for--unavailable">
          <span>Unavailable</span>
        </div>
      )}
       { popOverVisible && <div className="overlay-modal"></div>}
      <Popover
        placement="bottomLeft"
        visible={currentOpenModalIndex === index && popOverVisible}
        content={
          <GetGenericDrugPopOver
            index={index}
            showContentCount={showContentCount}
            showMoreState={showMoreState}
            setShowMoreState={setShowMoreState}
            setShowContentCount={setShowContentCount}
            setShowPopOverVisible={setShowPopOverVisible}
          />
        }
        trigger="click"
      >
        {dataState[index].genericDrugBrand === null && dataState[index].isGenericOptionAvailable === true && getAddGenericOptionFormat()}
        {dataState[index].genericDrugBrand !== null && dataState[index].isGenericOptionAvailable === true && getEditGenericOptionFormat()}
      </Popover>
    </Fragment>
  );
};

export default GenericOptionDisplayFormat;
